import React from 'react';
import { AccreditationCentersListContainer } from '../../containers';

const AccreditationCentersListPage = () => <AccreditationCentersListContainer />;

export default AccreditationCentersListPage;
